var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7525 9.00008C17.7545 9.25643 17.6766 9.50703 17.5296 9.71705C17.3825 9.92707 17.1738 10.0861 16.9322 10.172L11.976 11.9743L10.1744 16.9298C10.0856 17.169 9.92572 17.3753 9.71623 17.521C9.50674 17.6667 9.25769 17.7448 9.00252 17.7448C8.74735 17.7448 8.49829 17.6667 8.2888 17.521C8.07932 17.3753 7.91944 17.169 7.83064 16.9298L6.02908 11.9735L1.07283 10.172C0.83361 10.0832 0.627293 9.92328 0.481599 9.71379C0.335905 9.5043 0.257812 9.25525 0.257812 9.00008C0.257812 8.74491 0.335905 8.49585 0.481599 8.28636C0.627293 8.07688 0.83361 7.917 1.07283 7.8282L6.02908 6.02664L7.83064 1.07039C7.91944 0.831168 8.07932 0.624852 8.2888 0.479158C8.49829 0.333464 8.74735 0.255371 9.00252 0.255371C9.25769 0.255371 9.50674 0.333464 9.71623 0.479158C9.92572 0.624852 10.0856 0.831168 10.1744 1.07039L11.9767 6.02664L16.9322 7.8282C17.1738 7.91408 17.3825 8.07308 17.5296 8.2831C17.6766 8.49312 17.7545 8.74372 17.7525 9.00008Z",
    fill: "url(#paint0_linear_393_82851)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_82851",
    x1: 0.257812,
    y1: 17.7448,
    x2: 20.997,
    y2: 6.52425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmiration);
export default __webpack_public_path__ + "static/media/Admiration.3636ef2351bfc64b8d0ce35b94b9ea03.svg";
export { ForwardRef as ReactComponent };